export default "__VITE_ASSET__$ZuS1vpv__"